module.exports = __webpack_public_path__ + "img/empty-data.3a0f565c.png";